import React, { FC } from 'react';
import { useDashboard } from '../../../contexts';
import {
  ActivityLogLayout,
  JournalSection,
  TradesTableSection,
} from './components';

export const ActivityLog: FC = () => {
  const { account } = useDashboard();

  if (!account) {
    return null;
  }

  return (
    <ActivityLogLayout>
      <TradesTableSection />
      <JournalSection />
    </ActivityLogLayout>
  );
};
